import { transactionTypePositionCheck } from './helper';

export const buildPaymentMeansPayload = (paymentMeans, profileExecutionId) => {
  const isDeemedSupply = transactionTypePositionCheck(profileExecutionId, 2);

  const list = Array.isArray(paymentMeans) ? paymentMeans : paymentMeans ? [paymentMeans] : [];

  const valid = list.filter((pm) => pm?.payment_means_code?.trim());

  if (isDeemedSupply && valid.length === 0) {
    return undefined;
  }
  return valid;
};
